import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import store from '../store'
// import { getToken } from '@/utils/auth'
import Qs from 'qs'


//获取地址栏URL，判断问号后面拼接的字符串是否含有'lang'
function getUrlParam(name){
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    let a=window.location.href.split('?')[1];
    let b='?'+a;
    let r = b.substr(1).match(reg);    //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null;    //返回参数值
}


// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
//   timeout: 50000, // 请求超时时间
  withCredentials : true,
  transformRequest: [function (data) {
    data = Qs.stringify(data);    
    return data;
  }],
})


// request 请求拦截器
service.interceptors.request.use(
  config => {
    if (localStorage.token) {
        config.headers['token'] = localStorage.token; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config    
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 响应拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非0是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code  != '0') {
    //   console.log(res)
    //   Message({
    //     message: '票务系统温馨提示：'+res.msg,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   let aaauser = window.location.href.split('?')[0];   //当地址栏是主页的时候，不弹出后台接口的错误信息
    //   let bbbuser = aaauser.split('#')[1];
    //   if(bbbuser != "/"){
        if (res.code == 1 || res.code == 50008 ) {      // 50008: cooke过期或未登录
                Message({
                    message: '票务系统温馨提示：'+res.msg,
                    type: 'error',
                    duration: 5 * 1000
                })
        }  
    //   }
      // 50008: cooke过期或未登录; 50012:用户接口未登录（ticketAppUser，只有这一个接口50012）;
        if (res.code == 50012) {
        //  Message({
        //       message: '票务系统温馨提示：您还没有登录，或登录已失效，请重新登录',   
        //       type: 'error'
        //   })
        //   setTimeout(()=>{

        //     location.reload() // 为了重新实例化vue-router对象 避免bug
        //   },2000)
        // MessageBox.confirm(
        //   '你已被登出，可以取消继续留在该页面，或者重新登录',
        //   '确定登出',
        //   {
        //     confirmButtonText: '重新登录',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }
        // ).then(() => {
        //   store.dispatch('FedLogOut').then(() => {
        //     location.reload() // 为了重新实例化vue-router对象 避免bug
        //   })
        // })

        //如果res.code==50008，则未登录，清空本地保存的username
        // localStorage.removeItem("username");

        }
        return Promise.reject(res.msg)
      
    } else {
    //   console.log(response.data)
      if(response.data==null){
        return {}
      }else{
        return response.data
      }
    }
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //     message: '网络超时',
    //     type: 'error',
    //     duration: 5 * 1000
    // }) 
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/untils/request.js